import { render, staticRenderFns } from "./DelivTime.vue?vue&type=template&id=230983c3&lang=pug"
import script from "./DelivTime.vue?vue&type=script&lang=js"
export * from "./DelivTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports